export default "__VITE_ASSET__9ad00dee__"